import React from 'react';
import { useDispatch } from 'react-redux';
import gql from 'graphql-tag';
import { hooks } from 'lib.front';
import { clientLog } from 'common/gqlClientes';
import { logIn, loadingModal, openMsg } from 'redux-app';
import { validacion } from 'lib.common'

const logInQ = gql`
query LogIntra($user: String!, $pass: String!) {
   logIntra(user: $user, pass: $pass) {
      codigo
      tipoDoc
      nroDoc
      nombre
      apPaterno
      apMaterno
      razonSocial
      usuario
      email
      telefono
      contacto
      fechaVigencia
      asesorResponsable
   }
}
`;
export default function useLogIn(setLogResult) {
   //REDUX
   const dispatch = useDispatch();
   //CALLBACKS LOGIN
   function callbackProcesarData(data) {
      if (!validacion.esVarNullUndef(data)) {
         let dataAux = data[Object.keys(data)[0]];
         if (dataAux != null) {
            if (dataAux.codigo != null) {
               dispatch(logIn(data.logIntra));
               setLogResult('');
            } else {
               setLogResult('Usuario o Password incorrectos');
            }
         } else {
            setLogResult('Usuario o Password incorrectos');
         }
      }

   }

   function callbackLoading(loading) {
      dispatch(loadingModal(loading));
   }

   function callbackError(error) {
      dispatch(openMsg(JSON.stringify(error)));
   }

   const [loginCall] = hooks.useApolloLazyQ(
      logInQ,
      {
         callbackProcesarData: callbackProcesarData,
         callbackLoading: callbackLoading,
         callbackError: callbackError
      },
      {
         client: clientLog
      }
   );
   return loginCall;
}
